<template>
  <v-card 
    class="pb-2"
    style="max-width: 100%; width: 100%"
  >
    <v-toolbar
      flat
    >
      <v-text-field 
        v-if="editionMode"
        v-model="label" 
        :placeholder="$t('campaigns.label.userGroupPlaceholder')" 
        persistent-placeholder 
        :hint="$t('campaigns.label.userGroupHint')"
      ></v-text-field>
      <v-card-title v-else>{{ label }}</v-card-title>
      <v-chip-group v-if="!editionMode">
        <v-chip v-for="user in richUsers" :key="user.username">
          {{ user.profilename }}
        </v-chip>
      </v-chip-group>
      <v-spacer></v-spacer>
      <v-btn
        v-if="editionMode"
        icon
        @click="deleteItem"
      >
        <v-icon>{{ userGroup.existing ? 'mdi-delete' : 'mdi-close' }}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container v-if="editionMode" fluid class="py-0">
      <v-row>    
        <v-col :cols="editionMode ? 12 : 6" class="py-0">
          <v-subheader v-if="!editionMode" class="pl-0">
            {{ $t('campaigns.label.users') }}
          </v-subheader>
          <v-select
            dense
            v-if="editionMode"
            v-model="users"
            :items="availableAndDeletedUsers"
            item-text="profilename"
            item-value="username"
            multiple
            chips
            :hint="$t('campaigns.label.users')"
            persistent-hint
          ></v-select>
          <v-chip-group v-else>
            <v-chip v-for="user in richUsers" :key="user.username">
              {{ user.profilename }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: ["editionMode", "userGroupIdx", "userGroup", "jsonpath", "availableUsers"],
  mounted() {
  },
  computed: {
    richUsers() {
      return this.editionMode || !this.availableUsers || !this.users ? [] : this.users.map(username => {
        const result = this.availableUsers.find(user => user.username == username)
        if (!result) {
          return {username, profilename:"<user no longer exists>"}
        }
        return result
      })
    },
    availableAndDeletedUsers() {
      const deletedUsers = []
      for (let username of this.userGroup.users) {
        const result = this.availableUsers.find(user => user.username == username)
        if (!result) {
          deletedUsers.push({username, profilename:"<user no longer exists>"})
        }
      }
      return [...deletedUsers, ...this.availableUsers]
    },
    label: {
      get() {
        const label = this.userGroup.label;
        return label ? label : ""
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { label: value }}})
      }
    },
    users: {
      get() {
        const users = this.userGroup.users;
        return users ? users : []
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { users: value }}})
      }
    },
  },
  methods: {
    deleteItem() {
      this.$emit("delete", this.userGroupIdx)
    }
  },

}
</script>